import {Action, Selector, State, StateContext} from '@ngxs/store';
import {ValidationError} from '../../../domain/error.model';
import {GrowlService} from '../service/growl.service';
import {Injectable} from '@angular/core';

export namespace ErrorsAction {

    export class CleanAside {
        static readonly type = 'ErrorsAction.CleanAside';
    }

    export class CleanMain {
        static readonly type = 'ErrorsAction.CleanMain';
    }

    export class CleanDialog {
        static readonly type = 'ErrorsAction.CleanDialog';
    }

    export class SaveAside {
        static readonly type = 'ErrorsAction.SaveAside';

        constructor(public errors: ValidationError[]) {
        }
    }

    export class SaveMain {
        static readonly type = 'ErrorsAction.SaveMain';

        constructor(public errors: ValidationError[]) {
        }
    }

    export class SaveDialog {
        static readonly type = 'ErrorsAction.SaveDialog';

        constructor(public errors: ValidationError[]) {
        }
    }
}

export class ErrorsStateModel {
    aside: ValidationError[];
    main: ValidationError[];
    dialog: ValidationError[];
}

@State<ErrorsStateModel>({
    name: 'errors',
    defaults: {
        aside: [],
        main: [],
        dialog: [],
    }
})
@Injectable()
export class ErrorsState {

    constructor(private growlService: GrowlService) {
    }

    @Selector()
    static getAsideErrors(state: ErrorsStateModel) {
        return state.aside;
    }

    @Selector()
    static getMainErrors(state: ErrorsStateModel) {
        return state.main;
    }

    @Selector()
    static getDialogErrors(state: ErrorsStateModel) {
        return state.dialog;
    }

    @Action(ErrorsAction.CleanAside)
    cleanAside(context: StateContext<ErrorsStateModel>) {
        return context.patchState({aside: []});
    }

    @Action(ErrorsAction.CleanMain)
    cleanMain(context: StateContext<ErrorsStateModel>) {
        return context.patchState({main: []});
    }

    @Action(ErrorsAction.CleanDialog)
    cleanDialog(context: StateContext<ErrorsStateModel>) {
        return context.patchState({dialog: []});
    }

    @Action(ErrorsAction.SaveAside)
    saveAside(context: StateContext<ErrorsStateModel>, action: ErrorsAction.SaveAside) {
        this.growlService.showErrorGrowl('LABEL.SAVE_FAILED');
        return context.patchState({aside: action.errors});
    }

    @Action(ErrorsAction.SaveMain)
    saveMain(context: StateContext<ErrorsStateModel>, action: ErrorsAction.SaveMain) {
        this.growlService.showErrorGrowl('LABEL.SAVE_FAILED');
        return context.patchState({main: action.errors});
    }

    @Action(ErrorsAction.SaveDialog)
    saveDialog(context: StateContext<ErrorsStateModel>, action: ErrorsAction.SaveDialog) {
        this.growlService.showErrorGrowl('LABEL.SAVE_FAILED');
        return context.patchState({dialog: action.errors});
    }
}
